import styled from "@emotion/styled";

export const StyledTooltipContent = styled.div`
    background-color: ${({ theme }) => theme.colors.secondary[700]};
    color: ${({ theme }) => theme.colors.neutral[50]};
    max-width: 300px;
    padding: ${({ theme }) => theme.spacing[2]};
    border-radius: 16px;
`;
